<!-- =========================================================================================
  File Name: StudentView.vue
  Description: Student View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-student-view">

    <vs-alert color="danger" title="Student Not Found" :active.sync="student_not_found">
      <span>Student record with studentID: {{ this.studentID }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'student-list'}" class="text-inherit underline">All Students</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="student_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="개인정보">
            <div class="tab-text">
              <student-view-tab-information class="mt-4" :data="student_data" />
            </div>
          </vs-tab>
          <vs-tab label="수업관리">
            <div class="tab-text">
              <student-view-tab-class class="mt-4" :data="student_data" />
            </div>
          </vs-tab>
          <vs-tab label="학습이력">
            <div class="tab-text">
              <student-view-tab-study class="mt-4" :data="student_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import StudentViewTabInformation from './StudentViewTabInformation.vue'
import StudentViewTabClass from './StudentViewTabClass.vue'
import StudentViewTabStudy from './StudentViewTabStudy.vue'

import { fetchData } from '@/api/module'

export default {
  components: {
    StudentViewTabInformation,
    StudentViewTabClass,
    StudentViewTabStudy
  },
  data () {
    return {
      studentID: this.$route.params.studentID,
      student_data: null,
      student_not_found: false,
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_student_data(this.studentID)
    }
  },
  methods: {
    async fetch_student_data (studentID) {
      try {
        // const studentID = this.$route.params.studentID;
        // console.log(studentID);
        const { data } = await fetchData(`student/${studentID}`)
        this.student_data = data.data
        // console.log(data);
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.fetch_student_data(this.studentID)   
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-student-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
